import LoginFooter from 'modules/auth/login/footer';
import LoginHeader from 'modules/auth/login/header';
import {ReactNode} from 'react';

interface AuthWrapperProps {
  children: ReactNode;
}

const AuthWrapper = ({children}: AuthWrapperProps) => {
  return (
    <div className=" h-screen overflow-y-scroll">
      <div className="flex flex-col h-full justify-between mx-8">
        <LoginHeader />

        <div className="flex-1 flex justify-center mx-10">
          <div className="w-full mt-8">{children}</div>
        </div>

        <LoginFooter />
      </div>
    </div>
  );
};

export default AuthWrapper;
